import React from "react";
import { Navigate } from "react-router-dom";
import {
  isRouteAllowed,
  checkPermission,
  PermissionModule,
  PermissionIdentifier,
} from "../utils/permissionUtils";
import NotAllowed from "../global/NotAllowedPage/NotAllowed";

interface PermissionCheckProps {
  path: string;
  children: React.ReactNode;
  isCheckRoutePermission?: boolean;
  permissionConfig?: {
    module: PermissionModule;
    identifier: PermissionIdentifier;
  };
}

const PermissionCheck: React.FC<PermissionCheckProps> = ({
  path,
  children,
  isCheckRoutePermission,
  permissionConfig,
}) => {
  // Rule 1: If no permission check is needed, allow access
  if (!isCheckRoutePermission && !permissionConfig) {
    return <>{children}</>;
  }

  // Rule 2: Check route-based permission from menuItems
  if (isCheckRoutePermission) {
    const allowed = isRouteAllowed(path);
    if (!allowed) return <NotAllowed />;
  }

  // Rule 3: Check permission based on module+identifier
  if (permissionConfig) {
    const hasPermission = checkPermission(
      permissionConfig.module,
      permissionConfig.identifier
    );
    if (!hasPermission) return <NotAllowed />;
  }

  return <>{children}</>;
};

export default PermissionCheck;
